import React, {useEffect, useState} from 'react';
import OnboardInput from "../../component/base/onboard-input/OnboardInput";
import OnboardPassword from "../../component/base/onboard-password/OnboardPassword";
import OnboardButton from "../../component/base/onboard-button-component/OnboardButton";
import OnboardDialog from "../../component/base/onboard-dialog-component/OnboardDialog";
import NotNullCheck from "../../util/NotNullCheck";
import EndUseAgreementTTNETCheckbox from "../../component/custom/EndUseAgreementTTNETCheckbox";
import LoginStateManager from "../../util/LoginStateManager";
import VerifyTypeEnum from "../../enum/VerifyTypeEnum";

const LoginWithUsernamePasscode = (props) => {
    const {t, i18n} = props.props;

    const [error, setError] = useState(null);
    const [dialogError, setDialogError] = useState({error: false, title: "", content: ""});

    const {loginOther2} = new LoginStateManager(props.props, VerifyTypeEnum.OTHER_LOGIN);

    const validation = () => {
        if (NotNullCheck(control())) {
            loginOther2(username, password);
        }
    }

    const control = () => {
        let valid = {
            username: (username == null || username.length === 0) ? t('error.empty_username') : null,
            password: (password == null || password.length === 0) ? t('error.empty_password') : null,
            approve: (approve == null || !approve) ? t('error.empty_approve') : null,
        };
        setError(valid);
        return valid;
    }

    useEffect(() => {
        if (error !== null) {
            control();
        }
    }, [i18n.language])

    const [username, setUsername] = useState(null);
    const [password, setPassword] = useState(null);
    const [approve, setApprove] = useState(null);

    return (
        <div>
            <OnboardInput placeholder={t('login.username')} onChange={(e) => setUsername(e)}
                          error={error?.username}
                          value={username}
                          length={10}/>

            <div className="h-8"/>

            <OnboardPassword placeholder={t('login.password')} onChange={(e) => setPassword(e)}
                             error={error?.password} isNotNumber
                             value={password}
                             length={6}/>

            <div className="h-20"/>

            <EndUseAgreementTTNETCheckbox value={approve}
                                          error={error?.approve}
                                          onChange={(e) => setApprove(e)}
                                          hiddenMilesAndSmiles
            />

            <div className="h-20"/>

            <OnboardButton label={t('login.login_btn')} onClick={() => validation()}/>

            <OnboardDialog error confirm
                           visible={dialogError.error}
                           title={t('connection_error_dialog.title')}
                           content={t('connection_error_dialog.content')}
                           confirmText={t('connection_error_dialog.confirm')}
                           onClickConfirm={() => console.log("Ok")}
                           cancelText={t('connection_error_dialog.cancel')} cancelShow
                           onClickCancel={() => setDialogError({...dialogError, error: false})}
            />

        </div>
    );
};

export default LoginWithUsernamePasscode;

